let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("27dMt")).then(() => parcelRequire('h0wiX'));